module.exports = "/_next/static/images/nivedita-546ace9f36a7001e142163ace2b70297.png";